import { OrderedPostPart } from '@frontend/unhideschool/shared/models/dtos/ordered-post-part.model';
import { ProjectPost } from '@frontend/unhideschool/shared/models/project/project-post.model';

// ----------------
// COURSE LIST PAGE
// ----------------

export interface CourseListPagePaginationModel {
  page: number;
  perpage: number;
}

// -------------------
// COURSE LIST PROJECT
// -------------------

export interface CourseListPostRelatedUrlFiles {
  id: number;
  url: string;
  name: string;
}

export interface ProjectPostPaginationModel {
  page: number;
  perpage: number;
}

export interface CourseListProjectPostStateModel {
  projectposts: ProjectPost[] & any;
  postRelatedUrlFiles: { [k: number]: CourseListPostRelatedUrlFiles[] };
  orderedPostParts: { [k: number]: OrderedPostPart[] };
  notfound: boolean;
  postLimit: boolean;
  pagination: ProjectPostPaginationModel;
  lowerPriceCourseData?: IlowerPriceData;
  lowerPriceCareerData?: IlowerPriceData;
}

interface IlowerPriceData {
  original_price: string;
  lower_price: string;
  discount_percentage: number;
}

export const defaultCourseListState: CourseListProjectPostStateModel = {
  projectposts: [],
  postRelatedUrlFiles: {},
  orderedPostParts: {},
  postLimit: false,
  notfound: false,
  pagination: {
    page: 1,
    perpage: 5,
  },
};

export const defaultEmptyCourseListPost = {
  postid: 9999,
  title: 'loading',
  creator: {
    fullname: 'fullname',
    alias: 'alias',
  },
  galleries: [
    {
      galleryid: 0,
    },
  ],
  basictags: [
    {
      name: '3d',
      tagid: '155',
      tagtype: { internalname: 'basic' },
    },
    {
      name: 'ilustracao',
      slug: 'ilustracao',
      tagid: 437,
    },
    {
      name: 'animacao',
      slug: 'animacao',
      tagid: 483,
    },
    {
      name: 'fotografia',
      slug: 'fotografia',
      tagid: 667,
    },
    {
      name: 'retoque',
      slug: 'retoque',
      tagid: 54,
    },
  ],
};
